import { Box, styled } from '@mui/material';

const BoxContainer = styled(Box)(() => ({
  padding: '16px 24px',
  display: 'flex',
  gap: '24px',
  alignItems: 'flex-start',
  flexDirection: 'column',
  background: '#FFF',
  borderRadius: '16px',
  border: '1px solid #E6E6E6',
  width: '100%',
  marginTop: '24px'
}));

export default BoxContainer;
